import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApiHttpService } from "./services/api-http.service";
import { UserPreferenceService } from "./services/user-preference.service";
import { UppercaseDirective } from "./directives/upper-case.directive";
import { DateService } from "./services/date.service";
import { PmoProgramService } from "./services/pmo-program.service";
import { FileSaverService } from "./services/file-saver.service";
import { ToastrModule } from "ngx-toastr";
import { AlertService } from "./services/alert.service";
import { LoadingWrapperService } from "./services/loading-wrapper.service";
import { VerticalTabGroupComponent } from "./components/vertical-tab-group/vertical-tab-group.component";
import { VerticalTabComponent } from "./components/vertical-tab/vertical-tab.component";
import { RequestOptionsService } from "./services/request-options.service";
import { RequestOptionsResolver } from "./resolvers/request-options-resolver";
import { GeNameValidator } from "../request-creation/experiment-design/pollination-instructions/validators/ge-name.validator";
import { GeNameValidationService } from "./services/ge-name-validation.service";
import { RequestDesignResolver } from "./resolvers/request-design.resolver";
import { RequestDetailsResolver } from "./resolvers/request-details.resolver";
import { RequestService } from "./services/request.service";
import { IntegerValueAccessorDirective } from './directives/integer-value-accessor.directive';
import { ViewRequestsResolver } from "./resolvers/view-requests.resolver";
import { PlantCareTemplateService } from "./services/plant-care-template.service";
import { TacticalLiaisonService } from "./services/tactical-liaison.service";
import { CropService } from "./services/crop.service";
import { RequestPurposeService } from "./services/request-purpose.service";
import { RequestStatusService } from "./services/request-status.service";
import { UserService } from "./services/user.service";
import { CeSiteService } from "./services/ce-site.service";
import { ProductConceptService } from "./services/product-concept.service";
import { SubstrateService } from "./services/substrate.service";
import { IrrigationMethodService } from "./services/irrigation-method.service";
import { FertigationMethodService } from "./services/fertigation-method.service";
import { LightingInstructionService } from "./services/lighting-instruction.service";
import { TemperatureInstructionService } from "./services/temperature-instruction.service";
import { HumidityInstructionService } from "./services/humidity-instruction.service";
import { PesticideInstructionService } from "./services/pesticide-instruction.service";
import { PollinationCategoryService } from "./services/pollination-category.service";
import { FacilityTypeService } from "./services/facility-type.service";
import { AoiService } from "./services/aoi.service";
import { CeDatePickerComponent } from "./components/ce-date-picker/ce-date-picker.component";
import { BsDatepickerModule } from "ngx-bootstrap";
import { ValidatorsService } from './services/validators.service';
import { ContainerDefinitionService } from "./services/container-definition.service";
import { ConfirmationModalComponent } from "./components/confirmation-modal/confirmation-modal.component";
import { RequestCommentsService } from "./services/request-comments.service";
import { AllowedRoleDirective } from "./directives/allowed-role.directive";
import { CurrentUserService } from "./services/current-user.service";
import { CurrentUserResolver } from "./resolvers/current-user.resolver";
import { PollinationTypeService } from "./services/pollination-type.service";
import { TissueTypeService } from "./services/tissue-type.service";
import { GrowthStageService } from "./services/growth-stage.service";
import { LaboratoryService } from "./services/laboratory.service";
import { PlanningService } from "./services/planning.service";
import { FacilityNameService } from "./services/facility-name.service";
import { PollinationStakeLabelService } from "./services/pollination-stake-label.service";
import { SeedRequestService } from "./services/seed-request.service";
import { SeedRequestsResolver } from "./resolvers/seed-requests-resolver";
import { ProjectedTaskConfigurationService } from "./services/projected-task-configuration.service";
import { CeDateRangePickerDirective } from "./directives/ce-date-range-picker.directive";
import { RequestGridService } from "./services/request-grid.service";
import { RequestTypeService } from "./services/request-type.service";
import { SprayBoothStudyService } from "./services/spray-booth-study.service";


@NgModule({
  imports: [
    CommonModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true
    }),
    BsDatepickerModule.forRoot()
  ],
  declarations: [
    UppercaseDirective,
    VerticalTabGroupComponent,
    VerticalTabComponent,
    IntegerValueAccessorDirective,
    CeDatePickerComponent,
    CeDateRangePickerDirective,
    ConfirmationModalComponent,
    AllowedRoleDirective
  ],
  providers: [
    UserPreferenceService,
    ApiHttpService,
    DateService,
    PmoProgramService,
    FileSaverService,
    AlertService,
    LoadingWrapperService,
    RequestOptionsService,
    RequestOptionsResolver,
    GeNameValidator,
    GeNameValidationService,
    RequestService,
    RequestGridService,
    RequestDetailsResolver,
    RequestDesignResolver,
    ViewRequestsResolver,
    PlantCareTemplateService,
    TacticalLiaisonService,
    CropService,
    RequestPurposeService,
    RequestStatusService,
    UserService,
    CeSiteService,
    ProductConceptService,
    SubstrateService,
    IrrigationMethodService,
    FertigationMethodService,
    LightingInstructionService,
    TemperatureInstructionService,
    HumidityInstructionService,
    PesticideInstructionService,
    SprayBoothStudyService,
    PollinationCategoryService,
    FacilityTypeService,
    AoiService,
    ValidatorsService,
    ContainerDefinitionService,
    CurrentUserService,
    RequestCommentsService,
    CurrentUserResolver,
    PollinationTypeService,
    TissueTypeService,
    GrowthStageService,
    LaboratoryService,
    PlanningService,
    FacilityNameService,
    PollinationStakeLabelService,
    SeedRequestService,
    SeedRequestsResolver,
    ProjectedTaskConfigurationService,
    RequestTypeService
  ],
  exports: [
    UppercaseDirective,
    VerticalTabGroupComponent,
    VerticalTabComponent,
    IntegerValueAccessorDirective,
    CeDatePickerComponent,
    CeDateRangePickerDirective,
    ConfirmationModalComponent,
    AllowedRoleDirective
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/shared.module.ts